'use client';

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    return (
        <html lang="ko">
            <body style={{ margin: 0, fontFamily: "'Inter', sans-serif", background: '#0a0e1a', color: '#e2e8f0' }}>
                <div style={{
                    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
                }}>
                    <div style={{ maxWidth: 480, textAlign: 'center' }}>
                        <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
                        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>서비스 오류</h1>
                        <p style={{ fontSize: 14, color: '#64748b', marginBottom: 24, lineHeight: 1.6 }}>
                            일시적인 문제가 발생했습니다. 잠시 후 다시 시도해주세요.
                        </p>
                        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
                            <button onClick={reset}
                                style={{ padding: '10px 24px', borderRadius: 10, background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600 }}>
                                다시 시도
                            </button>
                            <button onClick={() => window.location.href = '/'}
                                style={{ padding: '10px 24px', borderRadius: 10, background: 'rgba(255,255,255,0.05)', color: '#94a3b8', border: '1px solid rgba(255,255,255,0.1)', cursor: 'pointer' }}>
                                홈으로
                            </button>
                        </div>
                    </div>
                </div>
            </body>
        </html>
    );
}
